<template>
  <div class="check-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem><div class="bread">确认订单</div></shBreadItem>
    </shBread>
  </div>
  <InfoCheck />
  <VideoCheck v-if="$route.query.type === 'video'" />
  <TestsCheck v-if="$route.query.type === 'tests'" />
  <BooksCheck v-if="$route.query.type === 'book'" />
</template>

<script>
import InfoCheck from "./components/info-check.vue";
import VideoCheck from "./components/video-check.vue";
import TestsCheck from "./components/tests-check.vue";
import BooksCheck from "./components/books-check.vue";
export default {
  components: {
    InfoCheck,
    VideoCheck,
    TestsCheck,
    BooksCheck,
  },
  setup() {
    return { InfoCheck, VideoCheck };
  },
};
</script>

<style lang="less" scoped>
.check-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
